import React from 'react';
import { block } from 'bem-cn';

import PionThumbnail from '../PionThumbnail';

import './pion-content-receipt.scss';
import { PionType, ImmutableMapItem } from '../../../type';

const b = block('pion-content-receipt');

type ReceiptPhotoPropsType = {
  pion: Pick<
    PionType,
    | keyof ImmutableMapItem
    | 'id'
    | 'title'
    | 'files'
    | 'pages'
    | 'pageUrl'
    | 'purchasedAt'
    | 'vendor'
  >;
};
const ReceiptPhoto = ({ pion }: ReceiptPhotoPropsType) => {
  const pages = pion.get('pages');
  const files = pion.get('files');
  let thumbnail = pages && pages.first();

  if (!thumbnail) {
    thumbnail = files && files.first();
  }

  return (
    <div className={b()}>
      <div className={b('thumbnail')}>
        {thumbnail && (
          <PionThumbnail
            url={thumbnail.get('smallUrl')}
            caption={thumbnail.get('caption')}
          />
        )}
      </div>
    </div>
  );
};

export default ReceiptPhoto;
